export default __webpack_public_path__ + "static/media/404.84edb9a9.png";